const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50) scale(1, 1) rotate(0) translate(-50 -50)",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 72.000005,1002.3569 c -0.028,-0.715 -0.3223,-1.5414 -0.8125,-2.0626 l -16,-17.00076 c -1.0842,-0.9743 -3.16322,-1.3765 -4.37502,-0.25 -1.1936,1.1095 -1.1581,3.2613 0.031,4.3752 l 11.25002,11.9381 -31.09352,0 c -1.6568,0 -3,1.34316 -3,3.00006 0,1.6569 1.3432,3.0001 3,3.0001 l 31.09352,0 -11.25002,11.9381 c -1.0237,1.0255 -1.2129,3.253 -0.031,4.3752 1.1816,1.1221 3.33532,0.7636 4.37502,-0.2501 l 16,-17.0007 c 0.5475,-0.5818 0.8143,-1.2644 0.8125,-2.0626 z",
    style: {
      textIndent: 0,
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      baselineShift: "baseline",
      color: "#000000",
      enableBackground: "accumulate"
    },
    fill: "#000000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    marker: "none",
    visibility: "visible",
    display: "inline",
    overflow: "visible"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.3f8f10924ac4cdedd3a31d68e6eb6e16.svg";
export { ForwardRef as ReactComponent };